
const digest = 'ba336e1f6253765e0bcdaba67b002ecd5c1c047b0c4d4a4392740addce023ab1';
const css = `._commandMenuItemIcon_1qab6_1 {
  margin-right: var(--spacer-1);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"commandMenuItemIcon":"_commandMenuItemIcon_1qab6_1"};
export { css, digest };
  